module.exports = __webpack_public_path__ + "img/date.f95a14c8.svg";